<app-breadcrumb *ngIf="showFilter" [master]="'Struktura sieci'" [parentName]="'Licencje Agent21'"[name]="'Lista'"></app-breadcrumb>
<div class="licensed-agent-list-container"  >
  <form *ngIf="showFilter" (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >

    <app-datepicker
      class="agent-licensed-list-filter"
      label="Data zgłoszenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="agent-licensed-list-filter"
      label="Data zgłoszenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict
      [multiple]="true" [dictType]="'agent_21_status'"
      [label]="'Status'" class="agent-licensed-list-filter"
      [(ngModel)]="initialFilters.in$status" name="in$status"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'contract_owner'"
      [label]="'Płatnik'" class="agent-licensed-list-filter"
      [(ngModel)]="initialFilters.payer" name="payer"
    ></app-dict>

    <app-dict-regionals
      [multiple]="false" [label]="'Regionalny'"
      class="agent-licensed-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="agent-licensed-list-filter agent-licensed-list-filter-long"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="agent-licensed-list-filter agent-licensed-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-datepicker
      class="agent-licensed-list-filter"
      label="Data wygaśnięcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$expirationAt" name="gte$expirationAt"
    ></app-datepicker>

    <app-datepicker
      class="agent-licensed-list-filter"
      label="Data wygaśnięcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$expirationAt" name="lte$expirationAt"
    ></app-datepicker>

    <mat-form-field class="agent-licensed-list-filter">
      <mat-label>Liczba dni do wygaśnięcia</mat-label>
      <input matInput min="0" type="number" placeholder="12345" name="daysToExpiration" [(ngModel)]="initialFilters.daysToExpiration">
    </mat-form-field>

    <mat-form-field class="agent-licensed-list-filter">
      <mat-label>NIP do faktury</mat-label>
      <input matInput placeholder="NIP do faktury" name="contains$invoiceNip" [(ngModel)]="initialFilters.contains$invoiceNip">
    </mat-form-field>

    <mat-form-field class="agent-licensed-list-filter">
      <mat-label>NIP do licencji</mat-label>
      <input matInput placeholder="NIP do licencji" name="contains$licenseNip" [(ngModel)]="initialFilters.contains$licenseNip">
    </mat-form-field>

  </form>

  <div *ngIf="showFilter" class="agent-licensed-list-buttons">
      <button *ngIf="(userPermissions | async).licensed_agent.admin_root" (click)="downloadReport()" [disabled]="!(userPermissions | async).licensed_agent.admin_root"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="items" multiTemplateDataRows>

      <ng-container matColumnDef="createAt">
        <th mat-header-cell *matHeaderCellDef> Data zgłoszenia </th>
        <td mat-cell *matCellDef="let element">
            <a class="default-link" [routerLink]="['/licencje-agent21/szczegoly', element.uuid]"> {{element.createdAt| date:'y-MM-dd'}}</a>
        </td>
      </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="payer">
      <th mat-header-cell *matHeaderCellDef> Płatnik </th>
      <td mat-cell *matCellDef="let element">
        {{element.payer?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        {{element.partner?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerRegional">
        <th mat-header-cell *matHeaderCellDef> Regionalny </th>
        <td mat-cell *matCellDef="let element">
            {{element.partner?.assetsRegional?.fullName}}
        </td>
    </ng-container>

    <ng-container matColumnDef="licenseEndDate">
      <th mat-header-cell *matHeaderCellDef> Data wygaśnięcia </th>
      <td mat-cell *matCellDef="let element" >
        {{element.expirationAt| date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="day">
      <th mat-header-cell *matHeaderCellDef> Dni do wygaśnięcia  </th>
      <td mat-cell *matCellDef="let element" >
        {{day(element.expirationAt)}}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>   </th>
      <td mat-cell *matCellDef="let element" >

        <button
          *ngIf="[AGENT_21_STATUS_IT_EXPIRES].includes(element?.status.key)  &&  (userPermissions | async).licensed_agent.read"
          [disabled]="!(userPermissions | async).licensed_agent.read"
          mat-icon-button matTooltip="Zgłoszenie do odnowienia"  (click)="statusTo(AGENT_21_STATUS_APPLICATION_FOR_RENEWAL,element.uuid)" color="primary"
        ><mat-icon>edit</mat-icon></button>

        <button
          *ngIf="[AGENT_21_STATUS_IT_EXPIRES].includes(element?.status.key)  &&  (userPermissions | async).licensed_agent.read"
          [disabled]="!(userPermissions | async).licensed_agent.read"
          mat-icon-button  matTooltip="Rezygnacja z odnowienia" (click)="statusTo(AGENT_21_STATUS_CANCELLATION_OF_RENEWAL,element.uuid)" color="warn"
        ><mat-icon>edit</mat-icon></button>

      </td>
    </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator  [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>

</div>
